var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tuwen"},[_c('div',[_c('p',[_vm._v("视频封面")]),_c('div',{staticClass:"tuwen_upload"},[_c('upload',{attrs:{"image":_vm.form.data.logo,"height":"75px","width":"75px"},on:{"uploadOk":_vm.uploadOk}})],1),_c('p',{staticClass:"mt20"},[_vm._v(" 播放链接 ")]),_c('div',[_c('a-input',{attrs:{"placeholder":"请填写播放链接"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }